import { render, staticRenderFns } from "./autobiography.vue?vue&type=template&id=43f58c47&scoped=true&"
import script from "./autobiography.vue?vue&type=script&lang=js&"
export * from "./autobiography.vue?vue&type=script&lang=js&"
import style0 from "./autobiography.vue?vue&type=style&index=0&id=43f58c47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f58c47",
  null
  
)

export default component.exports